module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrCodeMask"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "qrCode"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/funreport-qrcode.png"),
      "height": "123",
      "width": "123"
    }
  }), _vm._v(" "), _c('p', [_vm._v("关注公众号")]), _vm._v(" "), _c('p', [_vm._v("自动收到好友的性格分析报告")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-099717f6!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/qrcodeMask.vue
// module id = 125
// module chunks = 2